import { render, staticRenderFns } from "./AboutCommittees.vue?vue&type=template&id=39c4c1bc&"
import script from "./AboutCommittees.vue?vue&type=script&lang=js&"
export * from "./AboutCommittees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports